<ion-content class="page-content">
  <div class="safe-area-top h-full">
    <ng-content></ng-content>
  </div>
</ion-content>
